module.exports = new __parcel__URL__("quickrecovery.964f2075.png").toString();